export function citationFetchDataSuccess(citation) {
    return {
        type: "CITATION_FETCH_DATA_SUCCESS",
        citation,

    }
}


export  function  citationFetchData(url) {
    return (dispatch) =>{
        fetch(url)
            .then(response => {
                if (!response.ok){
                    throw new Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(citation => dispatch(citationFetchDataSuccess(citation)))
    }
}
